(ns ui.wallet.i18n.fr
  "French dictionary of the wallet page (see `ui.wallet.i18n`).")

(def dictionary
  {:page/loading "chargement..."
   :page/command-failed "Un problème est survenu. Réessayez, ou contactez-nous par le chat si cela se reproduit."

   :balance/total-available "Solde disponible"
   :balance/pay-as-you-go "Solde à l'usage"
   :balance/used-up "Ajoutez du crédit pour continuer à publier."
   :balance/view-usage "Voir la consommation"

   :payment/title "Paiement"
   :payment/method "Moyen de paiement"
   :payment/billing-email "E-mail de facturation"
   :payment/reference "Référence"
   :payment/update "Modifier le moyen de paiement"
   :payment/card [:fn/str "Carte ({{:last4}})"]
   :payment/wire-transfer "Virement bancaire"

   :billing-email/change "Modifier"
   :billing-email/new "Nouvel e-mail de facturation"
   :billing-email/save "Enregistrer"
   :billing-email/saving "Enregistrement..."
   :billing-email/cancel "Annuler"
   :billing-email/hint "Paddle, notre revendeur, envoie les reçus et les factures à cette adresse."
   :billing-email/shared-hint "Si plusieurs de vos organisations partagent ce compte de facturation, la modification s'applique à toutes."
   :billing-email/invalid "Veuillez saisir une adresse e-mail valide."
   :billing-email/taken "Cette adresse e-mail est déjà utilisée par un autre compte de facturation. Veuillez utiliser une autre adresse ou nous écrire dans le chat."

   :customer-conflict/title "Votre e-mail est déjà lié à un autre compte"
   :customer-conflict/text "Votre adresse e-mail appartient déjà au compte de facturation d'une autre organisation Storrito, et notre prestataire de paiement Paddle n'autorise qu'un compte de facturation par e-mail. Écrivez-nous dans le chat, nous allons régler cela."
   :customer-conflict/chat "Ouvrir le chat du support"
   :customer-conflict/support-message "Bonjour, je ne peux pas ouvrir le paiement : mon adresse e-mail appartient déjà à un autre compte de facturation."

   :top-up/title "Recharge automatique"
   :top-up/custom-amount "Montant personnalisé"
   :top-up/opening-checkout "Ouverture du paiement..."
   :top-up/amount-missing "Veuillez saisir un montant."
   :top-up/amount-too-small [:fn/str "Le minimum est de ${{:minimum}}."]
   :top-up/amount-too-large [:fn/str "Le maximum est de ${{:maximum}} par recharge. Pour des montants plus élevés, contactez-nous par le chat."]
   :top-up/per-month [:fn/str "${{:quantity}} chaque mois"]
   :top-up/per-year [:fn/str "${{:quantity}} chaque année"]
   :top-up/stops-on [:fn/str "Se termine le {{:date}}"]
   :top-up/next-on [:fn/str "Prochaine recharge le {{:date}}"]
   :top-up/status-cancellation-scheduled "annulation programmée"
   :top-up/status-payment-failed "paiement échoué"
   :top-up/status-active "active"
   :top-up/past-due "La dernière recharge n'a pas pu être débitée. "
   :top-up/update-payment-method "Mettez à jour votre moyen de paiement"
   :top-up/resume "Reprendre la recharge automatique"
   :top-up/cancel "Annuler la recharge automatique"
   :top-up/paddle-unavailable "Nous n'avons pas pu charger les détails de votre recharge automatique depuis Paddle. Veuillez réessayer dans un instant."
   :top-up/try-again "Réessayer"

   :plan/title-monthly "Recharge mensuelle"
   :plan/title-yearly "Recharge annuelle"
   :plan/switch "Passer au paiement à l'usage"
   :plan/switching "Changement en cours..."
   :plan/switch-confirm [:fn/str "Votre recharge récurrente de ${{:quantity}} prend fin maintenant ; le changement est gratuit. Votre solde et votre moyen de paiement sont conservés. Vous ne payez ensuite que lorsque vous ajoutez des crédits, ou automatiquement avec la recharge automatique."]
   :plan/wont-cover [:fn/str "Votre solde ne couvrira probablement pas vos comptes Instagram connectés jusqu'à la prochaine recharge le {{:date}} ; les stories ne sont plus publiées à $0."]
   :plan/wont-cover-advice "Activez la recharge automatique ci-dessous, ou ajoutez des crédits maintenant."

   :on-demand/add-credits "Ajouter du crédit"
   :on-demand/choose-amount "Choisissez un montant. Vous ne payez que ce que vous utilisez."
   :on-demand/auto-top-up "Recharge automatique"
   :on-demand/rule [:fn/str "Quand votre solde passe sous ${{:threshold}}, nous ajoutons ${{:amount}} automatiquement."]
   :on-demand/auto-top-up-hint "Optionnel. Vos stories continuent d’être publiées quand le solde baisse — désactivable à tout moment."
   :on-demand/add [:fn/str "Ajouter ${{:amount}}"]
   :on-demand/charged-once "Débité une seule fois maintenant via Paddle, notre revendeur. Votre carte est enregistrée pour les prochaines recharges, rien de récurrent. Le crédit n'est pas remboursable. Prix hors TVA."
   :on-demand/discount-off [:fn/str "{{:percent}} % de réduction sur"]
   :on-demand/discount-applied "Appliquée à votre tarif journalier dès votre premier rechargement, pas au montant que vous ajoutez. Le crédit de bienvenue est facturé au tarif normal."
   :on-demand/charged-to-card "Débité sur votre moyen de paiement enregistré, disponible en quelques secondes."
   :on-demand/confirm-charge [:fn/str "${{:amount}} USD hors taxes vous seront débités maintenant."]
   :on-demand/charging "Débit en cours..."
   :on-demand/add-now [:fn/str "Ajouter ${{:amount}} maintenant"]
   :on-demand/payment-accepted "Paiement accepté, votre solde se met à jour dans quelques secondes."
   :on-demand/prices-excl-vat "Prix hors TVA."
   :on-demand/amount-too-large [:fn/str "Le maximum est de ${{:maximum}} par recharge."]
   :on-demand/on "Activée"
   :on-demand/off "Désactivée"
   :on-demand/saving "Enregistrement..."
   :on-demand/save "Enregistrer"
   :on-demand/custom-auto-top-up-amount "Montant personnalisé de la recharge automatique"
   :on-demand/one-charge-per-day "Au plus un débit automatique par jour, sur votre moyen de paiement enregistré, plus les taxes applicables."
   :on-demand/remove-payment-method "Supprimer le moyen de paiement"

   :transactions/title "Transactions récentes"
   :transactions/full-statement "Relevé complet"
   :transactions/invoices "Factures"
   :transactions/date "Date"
   :transactions/description "Description"
   :transactions/amount "Montant"
   :transactions/error "Les transactions n'ont pas pu être chargées."
   :transactions/empty "Aucun achat ce mois-ci pour l'instant."
   :transactions/welcome-credits "Crédit de bienvenue"
   :transactions/recurring-top-up "Recharge récurrente"
   :transactions/added-credits "Crédit ajouté"
   :transactions/refund "Remboursement de crédit"

   :credit-notes/view "Avoirs"
   :credit-notes/title "Avoirs"
   :credit-notes/intro "Avoirs pour vos remboursements et crédits. Ils sont émis par Paddle, notre revendeur."
   :credit-notes/refund "Remboursement"
   :credit-notes/credit "Crédit"
   :credit-notes/download "Télécharger le PDF"
   :credit-notes/empty "Aucun avoir pour l'instant."
   :credit-notes/error "Les avoirs n'ont pas pu être chargés."

   :offer/applied-automatically "Appliquée automatiquement lorsque vous ajoutez des crédits. D'ici là, le crédit de bienvenue est facturé au tarif normal."

   :rates/view "Voir nos tarifs"
   :rates/title "Nos tarifs en un coup d'œil"
   :rates/intro "Voici ce que nous facturons par service. "
   :rates/intro-bold "Tous les prix sont en dollars américains hors taxes (hors TVA)."
   :rates/per-day "par jour"
   :rates/per-post "par publication"
   :rates/per-image "par image"
   :rates/per-days [:fn/str "par {{:days}} jours"]
   :rates/excl-vat "Tous les prix hors TVA"
   :rates/off [:fn/str "-{{:percent}}%"]

   :service.storage-flat-fee/name "Forfait stockage"
   :service.storage-flat-fee/description "pour toutes vos images, vidéos, etc."
   :service.instagram-connection/name "Connexion d'un compte Instagram"
   :service.instagram-connection/description "Stories et Reels illimités pour un nom d'utilisateur Instagram."
   :service.tiktok-post/name "Publication TikTok"
   :service.tiktok-post/description "Publiez une vidéo ou une image sur TikTok."
   :service.youtube-short/name "YouTube Short"
   :service.youtube-short/description "Publiez une vidéo rendue en YouTube Short."
   :service.social-post/name "Publication sociale"
   :service.social-post/description "Publiez une vidéo rendue ou une image sur Facebook, Threads et d'autres plateformes connectées (X est facturé séparément)."
   :service.x-post/name "Publication X"
   :service.x-post/description "Publiez une vidéo rendue sur X. X facture chaque publication faite via son API, c'est pourquoi les publications X coûtent plus cher que les autres publications sociales."
   :service.x-post-link/name "Publication X avec lien"
   :service.x-post-link/description "Une publication X dont le texte contient un lien. X facture beaucoup plus cher les publications avec des liens."
   :service.ai-image/name "Image IA"
   :service.ai-image/description "Génération d'une image par IA (Dall-e / Blackforest)."})
